/*eslint-disable */

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'highlight.js/lib/languages/css';
import './assets/fonts/strasua-regular/styles.css';
import './assets/fonts/myrid-pro/stylesheet.css';
import './assets/fonts/origintech-personal-use-webfont/stylesheet.css';
import 'highlight.js/lib/languages/javascript';
import 'highlight.js/styles/a11y-dark.css';
import "vue-tel-input/dist/vue-tel-input.css";
import 'vue-multiselect/dist/vue-multiselect.min.css';

import App from './App/index';
import VeeValidate from 'vee-validate';
import Vue from 'vue'
import VueHighlightJS from 'vue-highlightjs'
import VueRouter from 'vue-router';
import axios from 'axios';
import {getSafeLocalStorageItem} from '@/utils/localStorageHelper';
import highlightjs from './services/highlightjs';
import interceptor from './services/interceptor';
import router from './route';
import store from './store/store.js';
import timestamp from './services/timestamp';
import vco from "v-click-outside";

Vue.config.productionTip = false;
Vue.use(VueRouter, axios);
Vue.use(VeeValidate, {
  validity: true
});
// SynTaxHighlighter Register only languages that you want
Vue.use(VueHighlightJS)
Vue.use(vco);
// Bus

export const bus = new Vue();

// Ensure localStorage is accessible before attempting to use it
if (getSafeLocalStorageItem()) {
  store.dispatch('getAuthHeader');
  const token = localStorage.getItem('token');
  // Only set the Authorization header if a valid token exists
  if (token) { // Checks for null, undefined, and empty string
    axios.defaults.headers.common['Authorization'] = `Token ${token}`;
  }
}

var $ = window.jQuery = require('jquery');
if (navigator.userAgent.indexOf('Mac') > 0) {
  $('body').addClass('mac');
}
const scriptLoader = {
  loaded: [],
  load(src) {
    if (this.loaded.indexOf(src) !== -1) {
      return
    }
    this.loaded.push(src)
    if (document) {
      const script = document.createElement('script')
      script.setAttribute('src', src)
      document.head.appendChild(script)
    }
  }
}
Vue.use({
  install() {
    Vue.prototype.$scriptLoader = scriptLoader
  }
})
new Vue({
  render: h => h(App),
  router: router,
  store: store,
  interceptor,
  timestamp,
  highlightjs
}).$mount('#app')
